import { action } from 'satcheljs';

export const fetchLegacyUserDomainData = action('fetchLegacyUserDomainData');
